import { LinearProgress, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { loadingSelector } from '../../../store/selectors/loadingSelector';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  root: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    background: 'transparent',
    zIndex: 10000,
  },
  loader: {
    backgroundColor: 'transparent',
    position: 'absolute',
    width: '100%',
    height: '3px',
    zIndex: 10000,
    '& div': {
      backgroundColor: `${primary.blue2} !important`,
    },
  },
}));

const Loader = () => {
  const classes = useStyles();
  const { loading } = useSelector(loadingSelector);

  return (
    loading > 0 && (
      <div className={classes.root}>
        <LinearProgress className={classes.loader} />
      </div>
    )
  );
};

export default Loader;
